module.exports = __webpack_public_path__ + "img/logo.89602f1f.png";